module.exports = __webpack_public_path__ + "img/car-icon-selected.282185b2.svg";